import { AnimatePresence, motion } from "framer-motion";
import {
  NavButtonAction,
  NavButtonLink,
  SubNavButtonLink,
  SecondaryButtonLink,
} from "../../atoms/Buttons";
import Grid from "../../atoms/Grid";
import Image from "next/image";
import { fadeInOut } from "../../atoms/Animations";
import { InternalLinkIcon } from "../../atoms/Icons";
import { useState, useEffect } from "react";

export default function MenuModalLarge({
  menuItems,
  openModal,
  setOpenModal,
  setSearchOpen,
}) {
  const [isVisible, setIsVisible] = useState(false);
  const [activeItem, setActiveItem] = useState(null);

  useEffect(() => {
    if (openModal) {
      setActiveItem(openModal);
      setTimeout(() => setIsVisible(true), 50);
    } else {
      setIsVisible(false);
      setTimeout(() => setActiveItem(null), 300);
    }
  }, [openModal]);

  const handleNavButtonHover = (itemId) => {
    setOpenModal(itemId);
    setSearchOpen(false);
  };

  return (
    <ul className="hidden 1024:flex gap-x-24 h-full">
      {menuItems.length > 0 &&
        menuItems.map((item, index) =>
          item.submenu ? (
            <li className="flex h-full" key={index}>
              <NavButtonAction
                onMouseEnter={() => handleNavButtonHover(item.id)}
                text={item.title}
                active={openModal === item.id}
              />
              {activeItem === item.id && (
                <ul
                  className={`
                    menu-modal-lg bg-gray-200 transition-all duration-300 ease-in-out ${
                      isVisible ? "opacity-100" : "opacity-0"
                    }
                  `}
                  onMouseLeave={() => setOpenModal(null)}
                >
                  <Grid>
                    <div className="col-span-4 640:col-span-4 1024:col-span-6">
                      <div className="pl-16 640:pl-32 1024:pl-64 flex gap-x-24 py-32">
                        {item.submenu.map((area, index) => (
                          <div className="w-1/2" key={index}>
                            <div className="flex flex-col gap-y-32">
                              <span className="text-12 font-medium uppercase text-gray-600">
                                {area.area}
                              </span>
                              <ul className="flex flex-col">
                                {area.items.map((subItem, index) => (
                                  <li
                                    className="py-14 border-t border-gray-300"
                                    key={index}
                                  >
                                    <SubNavButtonLink
                                      text={subItem.title}
                                      href={subItem.slug}
                                      onClick={() => setOpenModal(null)}
                                    />
                                  </li>
                                ))}
                              </ul>
                              {area.viewAll && area.viewAll.slug ? (
                                <SecondaryButtonLink
                                  href={area.viewAll.slug}
                                  onClick={() => setOpenModal(null)}
                                  text={area.viewAll.title}
                                  icon={
                                    <InternalLinkIcon extraClass="stroke-theme-color !w-20 !h-20" />
                                  }
                                />
                              ) : (
                                <></>
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="col-span-4 640:col-span-4 1024:col-span-6 relative min-h-[450px]">
                      <Image
                        src={item.image}
                        fill
                        sizes="50vw"
                        className="w-full h-full object-cover"
                        alt=""
                      />
                    </div>
                  </Grid>
                </ul>
              )}
            </li>
          ) : (
            <li className="flex h-full" key={index}>
              <NavButtonLink
                text={item.title}
                href={item.slug}
                onClick={() => setOpenModal(null)}
                onMouseEnter={() => setOpenModal(null)}
              />
            </li>
          )
        )}
    </ul>
  );
}
